export default __webpack_public_path__ + "static/media/tierlitaenzli-chatzeschwaenzli.47946218.webp";